/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from "formik";
import { Label } from "components/Form";
import { Row, Col } from "components/Grid";
import BrokingSummary from "components/BrokingSummary";
import InputField from "components/Form/InputField";
import Layout from "components/Layout/index";
import SubTitle from "components/SubTitle";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer } from 'components/Button';
import TagInput from "components/TagInput";
import FileModal from "components/FileModal";
import { LostCancelButton, TextEditorBox } from 'components/index';

import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';

import { TextArea, ButtonContent } from "./styles";
import Loader from "components/Loader/index";
import Colors from "constants/Colors";
import StepNavigation from "components/StepNavigation/index";
import RenderButtons from 'components/RenderButtons';
import HasPermission from "components/HasPermission/index";
import CheckBox from 'components/Form/CheckBox';
import { useHeaderNbi, useFileNbiEmail, useListBrokers } from 'services/QuoteService'

export default function SendNbiRequest(props) {

  const [file, setFile] = useState();
  const [nbiMessage, setNbiMessage] = useState("");
  const [summary, setSummary] = useState({});
  const [contacts, setContacts] = useState([]);
  const [historymsg, setHistorymsg] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [attachmentsTag, setAttachmentsTag] = useState([]);
  const [brokersList, setBrokersList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isSelectedAll, setIsSelectedAll] = useState(false);

  const formikRef = useRef(null);
  const history = useHistory();
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useFileNbiEmailData,
    loading: useFileNbiEmailLoading,
    error: useFileNbiEmailError,
    status: useFileNbiEmailStatus,
    request: useFileNbiEmailRequest,
  } = useFileNbiEmail();

  const {
    data: useListBrokersData,
    loading: useListBrokersLoading,
    error: useListBrokersError,
    status: useListBrokersStatus,
    request: useListBrokersRequest,
  } = useListBrokers(props.match.params.idOperation);

  useEffect(() => {
    if (useHeaderNbiLoading || useFileNbiEmailLoading || useListBrokersLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, useFileNbiEmailLoading, useListBrokersLoading]);

  function handleContacts(contacts) {
    const tag = [];
    if (contacts) {
      contacts.forEach(contact => {
        tag.push(contact.email)
      });
    }
    return tag;
  };

  const handleAttachments = (attach) => {
    const tag = [];
    attach.forEach(e => {
      tag.push(e.file.fileName);
    })
    setAttachmentsTag(tag);
  }

  function handleBack() {
    history.goBack();
  };

  const goToLoginPage = () => {
    history.push('/login');
  };

  function getListBrokersByClient() {
    useListBrokersRequest().then(({data}) => {
        setBrokersList(data.ret_value);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${getListBrokersByClient.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });
  };

  function handleFileNbiRequestEmail() {
    useFileNbiEmailRequest({idOperation: props.match.params.idOperation, idTemplate: 186, exibition: true}, null).then(({data}) => {
        setFile(data);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFileNbiRequestEmail.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });
  };

  function handleFile() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestNbReqDocument(props.match.params.idOperation)
      .then(a => {
        if (a.status !== 200) {
          a.json().then(res => {
            mc.error(res.ret_msg_details);
            history.goBack();
            return;
          })

        } else {
          a.text().then((response) => {
            setFile(JSON.parse(response));
          })
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
        console.error('fitPostDocument - Error:', error);
      });
  };

  function base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  function saveByteArray(reportName, byte, t) {
    var blob = new Blob([byte], { type: t });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
  };

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        setHistorymsg(data.ret_value.historical);
        setContacts(data.ret_value.contacts);
        setNbiMessage(data.ret_value.nbiSubjectMessage);

        if (formikRef.current) {
          formikRef.current?.setFieldValue("subject", data.ret_value.nbiSubject);
        }

        if (data.ret_value.attachments) {
          setAttachments(data.ret_value.attachments);
          handleAttachments(data.ret_value.attachments);
        }

      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function handleHistoryMessage() {
    let tempmessage = "";
    if (historymsg?.length >= 1) {
      historymsg.map(
        (message, index) => {
          const tempMsg = `[${index + 1}] - Name: ${message.userFullName}, Date: ${message.approvalDate}
        ${message.approvalComments}
  
          `;
          tempmessage = (tempmessage + tempMsg);
        }
      )
      return tempmessage;
    }

  };

  function handleSendNbiRequest(values) {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestSendNbiRequest(props.match.params.idOperation, null, null, selectedItems)
      .then(response => response.json()).then(resp => {
        if (resp.ret_code != 200) {
          // mc.error(resp.ret_msg_details);
          return;
        }
      })
      .catch((error) => {
        // mc.error(`There was an error while fetching your data: ${handleSendNbiRequest.name}\n` + error);
        console.error('fitPostAproval - Error:', error);
      });
      setTimeout(() => {
        getStatusOperation()
      }, 3000);
  }

  function getStatusOperation() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGenerateNbiRequestStatus(props.match.params.idOperation).then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details || 'There was an error while processing your data, please try again');
          loading.stop();
          return;
        }

        if (data.ret_value.errorMessage && data.ret_value.errorMessage.trim().length) {
          mc.error(data.ret_value.errorMessage || 'There was an error while processing your data, please try again')
          loading.stop();
          return
        }

        if (data.ret_value.statusOperation === 'created') return history.push(`/broking/market-selection/${props.match.params.idOperation}`, { idProduct: props.location?.state?.idProduct });

        setTimeout(() => {
          getStatusOperation();
        }, 3000);

      }).catch((error) => {
        loading.stop();
        mc.error("There was an error while fetching your data:  \n" + error);
        console.error('fitPostListContact - Error:', error);
      });
  }

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);
      
    handleSummary();
    handleFileNbiRequestEmail();
    getListBrokersByClient();
  }, []);


  function isSelected(response) {
    const isSelected = selectedItems.find((item) => response.idPersonUser === item.idPersonUser);

    return isSelected != null;
  }

  function handleSelectAll(itens) {
    if (isSelectedAll) {
      setSelectedItems([])
      setIsSelectedAll(false)
    }
    else {
      const ableToSelect = itens.filter(i => i.email)
      setSelectedItems(ableToSelect);
      setIsSelectedAll(true)
    }
  };

  function handleSelect(response) {
    const alreadySelected = selectedItems.findIndex((item) => (response.idPersonUser === item.idPersonUser));

    if (alreadySelected !== -1) {
      const filteredItems = selectedItems.filter((_, i) => i !== alreadySelected);
      setSelectedItems(filteredItems);
      setIsSelectedAll(false)
    } else {
      setSelectedItems([...selectedItems, response]);
    }
  };

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary?.nmObligor ? summary?.nmObligor : "Broking name"}
      subtitle={summary?.dealCode ? summary?.dealCode : "Deal Code"}
    >
      <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />
      <ContentCard title="Send NBI Request" icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
        <Col md={12} style={{ marginBottom: "10px" }}>
          <Label>TO</Label>
          {
            !contacts ? "" : contacts
              .filter(contact => !contact?.insurer?.contacts?.find(v => v.dataSent))
              .sort((a, b) => String(a?.insurer?.nmInsuerFirstName).localeCompare(String(b?.insurer?.nmInsuerFirstName)))
              .map((contact, index) => (
                <>
                  {!(contact.insurer) ? "" :
                    <>
                      <div key={'contact' + index}>
                        <Label>{contact?.insurer?.nmInsuerFirstName}</Label>
                        <TagInput
                          readOnly
                          tags={handleContacts(contact?.insurer?.contacts)}
                        />
                      </div>
                    </>
                  }
                </>
              ))
          }
        </Col>

        <Formik
          innerRef={formikRef}
          initialValues={{
            CC: "",
            subject: "",
            attachments: [],
          }}
          onSubmit={(values) => handleSendNbiRequest(values)}
          render={({ values, setFieldValue }) => (

            <Form>
              <Col md={12}>
                <Row style={{ marginBottom: '12px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Label>BROKERS</Label>
                    {brokersList && brokersList.length > 0 && (
                      <div style={{ margin: '10px 0px' }}>
                        {/* <Label></Label> */}
                        <Label>
                          <CheckBox
                            type="checkbox"
                            checked={isSelectedAll}
                            onChange={() => handleSelectAll(brokersList)}
                          />
                          Select All
                        </Label>
                      </div>
                    )}

                    {brokersList && brokersList.map((broker, index) => (
                      <div key={index} style={{ display: 'flex' }}>
                        <Label>
                          <CheckBox
                            type="checkbox"
                            checked={isSelected(broker)}
                            onChange={() => handleSelect(broker)}
                          />
                        </Label>
                        <Label> {broker.nmPersonBroker}</Label>
                      </div>
                    ))}
                  </div>
                </Row>

                <Field
                  name="subject"
                  label="NBI Request e-mail Subject Line"
                  component={InputField}
                  value={values.subject}
                  disabled
                />

                {file && <FileModal idOperation={props?.match?.params?.idOperation} file={file} actions={false} />}

                {attachmentsTag.length >= 1 ?
                  <>
                    <Label>Attachments</Label>
                    <TagInput
                      readOnly
                      action={(index) => {
                        var sampleArr = base64ToArrayBuffer(attachments[index].file.fileBase64);
                        saveByteArray(attachments[index].file.fileName, sampleArr, attachments[index].file.type);
                      }}
                      tags={attachmentsTag}
                    />
                  </>
                  : ''}
                <Label>Deal Analysis Information</Label>
                <TextArea
                  readOnly
                  value={handleHistoryMessage()}
                />
              </Col>
              <ButtonContainer>
                <Button forth onClick={() => handleBack()}>&lt; Back</Button>
                <RenderButtons idOperation={props.match?.params?.idOperation}>
                  <ButtonContent>
                    <div style={{ marginTop: "5px" }}>
                      <LostCancelButton idOperation={props.match?.params?.idOperation} />
                    </div>
                    <HasPermission permission={props.permissions.MARKETS_SELECTION}>
                      <Button
                        style={{ marginLeft: "10px", marginTop: "5px" }}
                        type="submit"
                        primary
                        id="btnSubmit"
                      >
                        SEND NBI REQ
                      </Button>
                    </HasPermission>
                  </ButtonContent>
                </RenderButtons>
              </ButtonContainer>
            </Form>

          )}
        />
        {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
      </ContentCard>
    </Layout>
  );
}
